import React from 'react';

import BadgeInfo from '../BadgeInfo';
import BadgeSecondary from '../BadgeSecondary';

import { LotteryType } from 'Api/CRM/Responses/LotteryResponse';
import { BoolNumber, formatMatchBets } from 'base/utils/soccerHelpers';
import { LotteryTypes } from 'components/play/Types/Enums';
import { LineNumbers } from 'components/play/Types/Types';

export default function renderNumbers(numbers: LineNumbers, id: string | number, lotteryType: LotteryType) {
    const renderedNumbers: React.ReactNode[] = [];

    if (!numbers?.length) {
        return renderedNumbers;
    }

    switch (lotteryType) {
        case LotteryTypes.Pick:
            renderedNumbers.push(
                numbers.map((collection) =>
                    collection.map((number, i) => <BadgeInfo key={`${id}0${number}${i + 1}`} value={number} />)
                )
            );
            break;
        case LotteryTypes.Soccer:
            renderedNumbers.push(
                numbers
                    .slice(0, 14)
                    .map((matchBets: BoolNumber[], matchIndex) => (
                        <BadgeInfo key={`${id}${matchIndex + 1}`} value={formatMatchBets(matchBets, matchIndex)} />
                    ))
            );
            renderedNumbers.push(
                numbers
                    .slice(14)
                    .map((matchBets: BoolNumber[], matchIndex) => (
                        <BadgeSecondary
                            key={`${id}${matchIndex + 15}`}
                            value={formatMatchBets(matchBets, matchIndex + 14)}
                        />
                    ))
            );
            break;
        default:
            if (numbers[0]) {
                renderedNumbers.push(
                    numbers[0].map((number, i) => <BadgeInfo key={`${id}0${number}${i + 1}`} value={number} />)
                );
            }
            if (numbers[1]) {
                renderedNumbers.push(
                    numbers[1].map((number, i) => <BadgeSecondary key={`${id}1${number}${i + 1}`} value={number} />)
                );
            }
    }

    return renderedNumbers;
}
